import Abilities from './abilities';
export default Abilities;